import { useMemo } from 'react';
import {
    DEFAULT_PORT_NUMBER,
    LABEL_HOSTNAME,
    LABEL_HOSTNAME_IP,
    LABEL_PASSWORD,
    LABEL_PORT,
    LABEL_USERNAME,
    PASSWORD_FIELD,
    PORT_FIELD,
    USERNAME_FIELD,
    VCENTER_HOSTNAME_FIELD,
} from '../InfrastructureConstants';
import NgpTextField from '../../../form/NgpTextField';
import NgpPasswordField from '../../../form/NgpPasswordField';
import { AUTO_COMPLETE_DEFAULT } from '../../../../utilities/FormUtilities';
import NgpNumberField from '../../../form/NgpNumberField';
import NgpHostnameField from '../../../form/NgpHostnameField';
import { useVirtualInfraContext } from '../InfrastructureUtils';
import { DescriptionField, PollingStatusField } from '../InfrastructureFieldComponents';
import { FIELD_CONSTRAINTS } from '../FieldConstraints';

/**
 * Displays vCenter configuration fields
 * Includes hostname, credentials, port, polling status, and description
 * Hostname field is read-only for existing vCenters
 */
const VcenterFields = () => {
    const { isCreateAction } = useVirtualInfraContext();

    const hostnameLabel = useMemo(() => {
        return isCreateAction ? LABEL_HOSTNAME_IP : LABEL_HOSTNAME;
    }, [isCreateAction]);

    return (
        <>
            <NgpHostnameField
                fieldName={VCENTER_HOSTNAME_FIELD}
                label={hostnameLabel}
                inputProps={{ size: FIELD_CONSTRAINTS.HOSTNAME.size, maxLength: FIELD_CONSTRAINTS.HOSTNAME.maxLength }}
                disabled={!isCreateAction}
                required
            />
            <NgpTextField
                fieldName={USERNAME_FIELD}
                label={LABEL_USERNAME}
                inputProps={{
                    size: FIELD_CONSTRAINTS.USERNAME.size,
                    maxLength: FIELD_CONSTRAINTS.USERNAME.maxLength,
                    autoComplete: AUTO_COMPLETE_DEFAULT,
                }}
                required
            />
            <NgpPasswordField
                fieldName={PASSWORD_FIELD}
                label={LABEL_PASSWORD}
                inputProps={{ size: FIELD_CONSTRAINTS.PASSWORD.size, maxLength: FIELD_CONSTRAINTS.PASSWORD.maxLength }}
                togglePasswordVisibility
                required
            />
            <NgpNumberField
                fieldName={PORT_FIELD}
                label={LABEL_PORT}
                min={FIELD_CONSTRAINTS.PORT.min}
                max={FIELD_CONSTRAINTS.PORT.max}
                inputProps={{
                    placeholder: `${DEFAULT_PORT_NUMBER}`,
                    size: FIELD_CONSTRAINTS.PORT.size,
                    maxLength: FIELD_CONSTRAINTS.PORT.maxLength,
                }}
                required
            />
            {!isCreateAction && <PollingStatusField />}
            <DescriptionField />
        </>
    );
};

export default VcenterFields;
